import React, { useEffect } from "react";
import parser from "papaparse";
import { functionService } from "../../lib/functions";
import { useState } from "react";
import Sidemenu from "../sidemenu";
import csvDownload from "json-to-csv-export";
import { Button } from "antd";
import moment from "moment";

const Parser = () => {
  const [message, setMessage] = useState("");
  const [skills, setSkills] = useState();
  const [errorEntriesList, setErrorEntriesList] = useState([]);
  const [errorMessage, setErrorMessage] = useState([]);
  const [success,setSuccess]=useState(false)
  const [loading, setLoading] = useState(false);
  const [wrongCsvCheck,setWrongCsv]=useState(false);
  // const [errorCounter, setErrorCounter] =
  useEffect(() => {}, [message,loading,success]);
  // useEffect(() => {}, []);
  const getMasterSkills = async () => {
    const { response } = await functionService.get("userupdate/masterskills");
    setSkills(response?.data?.data?.masterSkillsList);
  };
  useEffect(() => {
    getMasterSkills();
  }, []);

  const uploadData = async (results) => {
    var payload = {},payloadArr=[];
    var skillupdatepayload = {};
    var skillpayload = [],skillPayloadArr=[];
    try {
      setLoading(true);
      for (let i = 0; i < results?.data?.length; i++) {
        let item = results?.data[i];

        try {


         payload["user_email"] = item["E-mail address"].trim();
          payload["current_salary"] = item["Current CTC (In Lacs)"];
          payload["expected_salary"] = item["Expected CTC (In Lacs)"];
          payload["negotiable"] = item["Negotiable"];
          payload["available_on"] = moment().add(item["Notice Period (In days)"], 'days').format() ;
         payload["location"] = item["Current Location"];
          payload["notice_period"] = item["Notice Period (In days)"];
         payload["vetted_experience"]= item["Total Experience"];
         payload["current_job_role"]=item["Current Job Role"]
         payload["company_name"]=item["Company Name"]
          payload["phone"]=item["Mobile Number (10 Digits)"]
         payload["preferred_location"]=item["Preferred Location"].split(',')
          payload["vetted"]=item["Vetted"]

          payloadArr.push(payload)
          skillpayload.push(item["Other Skill 1"]?item["Other Skill 1"]:"");
          skillpayload.push(item["Other Skill 2"]?item["Other Skill 2"]:"");
          skillpayload.push(item["Other Skill 3"]?item["Other Skill 3"]:"");
          skillpayload.push(item["Other Skill 4"]?item["Other Skill 4"]:"");
          skillpayload.push(item["Other Skill 5"]?item["Other Skill 5"]:"");
          skillpayload.push(item["Primary Skill"]?item["Primary Skill"]:"");
          skillupdatepayload["skillArr"] = skillpayload;
          skillupdatepayload["user_email"] = item["E-mail address"];
          skillPayloadArr.push(skillupdatepayload)
          skillupdatepayload={}
          skillpayload=[]
          payload={}
        } catch (error) {
          setMessage(error);
        }
      }

          const { status } = await functionService.post("userupdate", {payloadArr:payloadArr});

          const {status : skillStatus} = await functionService.post(
            "userupdate/skill",
            {skills:skillPayloadArr}
          );
      setSuccess(status&&skillStatus)
      // });
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setMessage("something went wrong");
    }
  };
  const handleFile = (e) => {
    setMessage("");
    setSuccess(false)
    setLoading(false)
    setWrongCsv(false)
    // errorCounter=0
    try {
      setErrorMessage([])
      setErrorEntriesList([]);
      if (e.target.files !== undefined) {
        setLoading(true);
        // setFileName(e.target.files[0]?.name);
        parser.parse(e.target?.files[0], {
          header: true,
          skipEmptyLines: true,
          complete: function (results) {
            const entriesWithError = [];
            const entriesWithErrorMessage=[]
            results &&
              results.data.map( (item) => {
                try {

                // if(item.__parsed_extra?.length>0){
                //   setMessage(
                //   "Please upload the correct file."
                //   );
                //   setWrongCsv(true)
                //   setSuccess(false)

                // }else{

                var payload = {};
                  var skillupdatepayload = {};
                  var skillpayload = [];

                  payload["user_email"] = item["E-mail address"];
                  payload["current_salary"] = item["Current CTC (In Lacs)"];
                  payload["expected_salary"] = item["Expected CTC (In Lacs)"];
                  payload["negotiable"] = item["Negotiable"];
                  payload["available_on"] =  moment().add(item["Notice Period (In days)"], 'days').format() ;
                  payload["location"] = item["Current Location"];
                  payload["notice_period"] = item["Notice Period (In days)"];
                  // payload["experience_year"] =
                  //   item["Total Experience"].split(".")[0];
                  // payload["experience_month"] =
                  //   item["Total Experience"].split(".")[1];
                  // payload["total_experience"] = item["Total Experience"];
                  payload["vetted_experience"]= item["Total Experience"];
                  payload["current_job_role"]=item["Current Job Role"]
                  payload["company_name"]=item["Company Name"]
                  payload["phone"]=item["Mobile Number (10 Digits)"]
                  payload["preferred_location"]=item["Preferred Location"]
                  payload["vetted"]=item["Vetted"]

                  // const res = await functionService.post(
                  //   "userupdate",
                  //   payload
                  // );

                  skillpayload.push(item["Other Skill 1"]?item["Other Skill 1"]:"");
                  skillpayload.push(item["Other Skill 2"]?item["Other Skill 2"]:"");
                  skillpayload.push(item["Other Skill 3"]?item["Other Skill 3"]:"");
                  skillpayload.push(item["Other Skill 4"]?item["Other Skill 4"]:"");
                  skillpayload.push(item["Other Skill 5"]?item["Other Skill 5"]:"");
                  skillpayload.push(item["Primary Skill"]?item["Primary Skill"]:"");
                  skillupdatepayload["skillArr"] = skillpayload;
                  skillupdatepayload["user_email"] = item["E-mail address"];
                  const {
                    user_email,
                    current_salary,
                    expected_salary,
                    negotiable,
                    available_on,
                    location,
                    notice_period,
                    vetted_experience,
                    current_job_role,company_name,phone,preferred_location,vetted
                  } = payload;
                  var flag1 = 0,
                    flag2 = 0,
                    flag3 = 0,
                    flag4 = 0,
                    flag5 = 0,
                    flag6 = 0;
                  if(item["Other Skill 1"]!==''&&item["Other Skill 1"]!==undefined){
                    skills.forEach((val) => {
                      if (item["Other Skill 1"] === val.name) {
                        flag1 = 1;
                      }
                    });

                  }
                  if(item["Other Skill 2"]!==''&&item["Other Skill 2"]!==undefined){
                    skills.forEach((val) => {
                      if (item["Other Skill 2"] === val.name) {
                        flag2 = 1;
                      }
                    });
                  }
                  if(item["Other Skill 3"]!=='' &&item["Other Skill 3"]!==undefined){
                    skills.forEach((val) => {
                      if (item["Other Skill 3"] === val.name) {
                        flag3 = 1;
                      }
                    });

                  }
                  if(item["Other Skill 4"]!==''&&item["Other Skill 4"]!==undefined){
                    skills.forEach((val) => {
                      if (item["Other Skill 4"] === val.name) {
                        flag4 = 1;
                      }
                    });

                  }
                  if(item["Other Skill 5"]!==''&&item["Other Skill 5"]!==undefined){
                    skills.forEach((val) => {
                      if (item["Other Skill 5"] === val.name) {
                        flag5 = 1;
                      }
                    });

                  }
                  if(item["Primary Skill"]!==''&&item["Primary Skill"]!==undefined){
                    skills.forEach((val) => {
                      if (item["Primary Skill"] === val.name) {
                        flag6 = 1;
                      }
                    });
                  }

                  // console.log(
                  //   "response==============>",
                  //   response.response.data.meta.message
                  // );

                  // if (
                  //   response?.response?.data?.meta?.message === "User exist"
                  // ) {
                    if (item["Other Skill 1"] !== "" && !flag1&&item["Other Skill 1"]!==undefined) {
                      entriesWithError.push({
                        user_email,
                        current_salary,
                        expected_salary,
                        negotiable,
                        available_on,
                        location,
                        notice_period,
                        vetted_experience,
                        current_job_role,
                        company_name,
                        phone,
                        preferred_location,vetted,
                        skill1: skillpayload[0],
                        skill2: skillpayload[1],
                        skill3: skillpayload[2],
                        skill4: skillpayload[3],
                        skill5: skillpayload[4],
                        primarySkill: skillpayload[5],
                        remark: "Other Skill 1 is not correct.",
                      });
                      entriesWithErrorMessage.push({
                        user_email,
                        current_salary,
                        expected_salary,
                        negotiable,
                        available_on,
                        location,
                        notice_period,
                        vetted_experience,
                        current_job_role,
                        company_name,
                        phone,
                        preferred_location,vetted,
                        skill1: skillpayload[0],
                        skill2: skillpayload[1],
                        skill3: skillpayload[2],
                        skill4: skillpayload[3],
                        skill5: skillpayload[4],
                        primarySkill: skillpayload[5],
                        remark: "Other Skill 1 is not correct.",
                      });
                      // errorCounter++;
                      // console.log("error============>",errorCounter);
                      // setErrorMessage("Other Skill 1 is not correct.")
                    } else if (item["Other Skill 2"] !== "" && !flag2&&item["Other Skill 2"]!==undefined) {
                      entriesWithError.push({
                        user_email,
                        current_salary,
                        expected_salary,
                        negotiable,
                        available_on,
                        location,
                        notice_period,
                        vetted_experience,
                        current_job_role,
                        company_name,
                        phone,vetted,
                        preferred_location,
                        skill1: skillpayload[0],
                        skill2: skillpayload[1],
                        skill3: skillpayload[2],
                        skill4: skillpayload[3],
                        skill5: skillpayload[4],
                        primarySkill: skillpayload[5],
                        remark: "Other Skill 2 name is not correct.",
                      });
                      entriesWithErrorMessage.push({
                        user_email,
                        current_salary,
                        expected_salary,
                        negotiable,
                        available_on,
                        location,
                        notice_period,
                        vetted_experience,
                        current_job_role,
                        company_name,
                        phone,vetted,
                        preferred_location,
                        skill1: skillpayload[0],
                        skill2: skillpayload[1],
                        skill3: skillpayload[2],
                        skill4: skillpayload[3],
                        skill5: skillpayload[4],
                        primarySkill: skillpayload[5],
                        remark: "Other Skill 2 name is not correct.",
                      });

                      // errorCounter++;
                      // console.log("error============>",errorCounter);
                    } else if (item["Other Skill 3"] !== "" && !flag3&&item["Other Skill 3"]!==undefined) {
                      entriesWithError.push({
                        user_email,
                        current_salary,
                        expected_salary,
                        negotiable,
                        available_on,
                        location,
                        notice_period,
                        vetted_experience,
                        current_job_role,
                        company_name,
                        phone,vetted,
                        preferred_location,
                        skill1: skillpayload[0],
                        skill2: skillpayload[1],
                        skill3: skillpayload[2],
                        skill4: skillpayload[3],
                        skill5: skillpayload[4],
                        primarySkill: skillpayload[5],
                        remark: "Other Skill 3 name is not correct.",
                      });
                      entriesWithErrorMessage.push({
                        user_email,
                        current_salary,
                        expected_salary,
                        negotiable,
                        available_on,
                        location,
                        notice_period,
                        vetted_experience,
                        current_job_role,
                        company_name,
                        phone,vetted,
                        preferred_location,
                        skill1: skillpayload[0],
                        skill2: skillpayload[1],
                        skill3: skillpayload[2],
                        skill4: skillpayload[3],
                        skill5: skillpayload[4],
                        primarySkill: skillpayload[5],
                        remark: "Other Skill 3 name is not correct.",
                      });
//                       errorCounter++;
// console.log("error============>",errorCounter);
                    } else if (item["Other Skill 4"] !== "" && !flag4&&item["Other Skill 4"]!==undefined) {
                      entriesWithError.push({
                        user_email,
                        current_salary,
                        expected_salary,
                        negotiable,
                        available_on,
                        location,
                        notice_period,
                        vetted_experience,
                        current_job_role,
                        company_name,
                        phone,vetted,
                        preferred_location,
                        skill1: skillpayload[0],
                        skill2: skillpayload[1],
                        skill3: skillpayload[2],
                        skill4: skillpayload[3],
                        skill5: skillpayload[4],
                        primarySkill: skillpayload[5],
                        remark: "Other Skill 4 name is not correct.",
                      });
                      entriesWithErrorMessage.push({
                        user_email,
                        current_salary,
                        expected_salary,
                        negotiable,
                        available_on,
                        location,
                        notice_period,
                        vetted_experience,
                        current_job_role,
                        company_name,
                        phone,vetted,
                        preferred_location,
                        skill1: skillpayload[0],
                        skill2: skillpayload[1],
                        skill3: skillpayload[2],
                        skill4: skillpayload[3],
                        skill5: skillpayload[4],
                        primarySkill: skillpayload[5],
                        remark: "Other Skill 4 name is not correct.",
                      });
//                       errorCounter++;
// console.log("error============>",errorCounter);
                    } else if (item["Other Skill 5"] !== "" && !flag5&&item["Other Skill 5"]!==undefined) {
                      entriesWithError.push({
                        user_email,
                        current_salary,
                        expected_salary,
                        negotiable,
                        available_on,
                        location,
                        notice_period,
                        vetted_experience,
                        current_job_role,
                        company_name,
                        phone,vetted,
                        preferred_location,
                        skill1: skillpayload[0],
                        skill2: skillpayload[1],
                        skill3: skillpayload[2],
                        skill4: skillpayload[3],
                        skill5: skillpayload[4],
                        primarySkill: skillpayload[5],
                        remark: "Other Skill 5 name is not correct.",
                      });
                       entriesWithErrorMessage.push({
                        user_email,
                        current_salary,
                        expected_salary,
                        negotiable,
                        available_on,
                        location,
                        notice_period,
                        vetted_experience,
                        current_job_role,
                        company_name,
                        phone,vetted,
                        preferred_location,
                        skill1: skillpayload[0],
                        skill2: skillpayload[1],
                        skill3: skillpayload[2],
                        skill4: skillpayload[3],
                        skill5: skillpayload[4],
                        primarySkill: skillpayload[5],
                        remark: "Other Skill 5 name is not correct.",
                      });
//                       errorCounter++;
// console.log("error============>",errorCounter);
                    } else if (item["Primary Skill"] !== "" && !flag6&&item["Primary Skill"]!==undefined) {
                      entriesWithError.push({
                        user_email,
                        current_salary,
                        expected_salary,
                        negotiable,
                        available_on,
                        location,
                        notice_period,
                        vetted_experience,
                        current_job_role,
                        company_name,
                        phone,vetted,
                        preferred_location,
                        skill1: skillpayload[0],
                        skill2: skillpayload[1],
                        skill3: skillpayload[2],
                        skill4: skillpayload[3],
                        skill5: skillpayload[4],
                        primarySkill: skillpayload[5],
                        remark: "Primary Skill name is not correct.",
                      });
                      entriesWithErrorMessage.push({
                        user_email,
                        current_salary,
                        expected_salary,
                        negotiable,
                        available_on,
                        location,
                        notice_period,
                        vetted_experience,
                        current_job_role,
                        company_name,
                        phone,vetted,
                        preferred_location,
                        skill1: skillpayload[0],
                        skill2: skillpayload[1],
                        skill3: skillpayload[2],
                        skill4: skillpayload[3],
                        skill5: skillpayload[4],
                        primarySkill: skillpayload[5],
                        remark: "Primary Skill name is not correct.",
                      });
                      // setErrorMessage("Primary Skill is not correct.")
                      // errorCounter++;
                    }else{
                      entriesWithError.push({
                        user_email,
                        current_salary,
                        expected_salary,
                        negotiable,
                        available_on,
                        location,
                        notice_period,
                        vetted_experience,
                        current_job_role,
                        company_name,
                        phone,
                        preferred_location,vetted,
                        skill1: skillpayload[0],
                        skill2: skillpayload[1],
                        skill3: skillpayload[2],
                        skill4: skillpayload[3],
                        skill5: skillpayload[4],
                        primarySkill: skillpayload[5],
                        remark: "Passed",
                      });
                    }
                  // } else if (
                  //   response?.response?.data?.meta?.message ===
                  //   "User does not exist"
                  // ) {
                  //   entriesWithError.push({
                  //     user_email,
                  //     current_salary,
                  //     expected_salary,
                  //     negotiable,
                  //     available_on,
                  //     location,
                  //     notice_period,
                  //     total_experience,
                  //     skill1: skillpayload[0],
                  //     skill2: skillpayload[1],
                  //     skill3: skillpayload[2],
                  //     skill4: skillpayload[3],
                  //     skill5: skillpayload[4],
                  //     primarySkill: skillpayload[5],
                  //     remark: "Email does not exist",
                  //   });
                  // }




    }
 catch (error) {
                  setMessage(error);
                }
              });
                  setErrorMessage(entriesWithErrorMessage)
                  setErrorEntriesList(entriesWithError);
// console.log(errorEntriesList);
                  if (
                    entriesWithErrorMessage?.length>0 ||errorMessage?.length>0
                  ) {
                    setMessage(
                      "There is some error with the uploaded file. Please download the error file, update it and upload it again."
                    );
                  } else {
                    if(!wrongCsvCheck){
                      // console.log("CALLEd");
                      uploadData(results);
                    }
                  }
          },
        });
        setLoading(false);
      }
    } catch (err) {
      setLoading(false);

      setMessage(err["message"]);
    }
  };

  const downloadErrorFile = () => {
    const dataToConvert = {
      data: errorEntriesList.map(
        ({
          user_email,
          current_salary,
          expected_salary,
          negotiable,
          available_on,
          location,
          notice_period,
          vetted_experience,
          current_job_role,
          company_name,
          phone,vetted,
          preferred_location,
          skill1,
          skill2,
          skill3,
          skill4,
          skill5,
          primarySkill,
          remark,
        }) => {
          return {
            user_email,
          current_salary,
          expected_salary,
          negotiable,
          available_on,
          location,
          notice_period,
          vetted_experience,
          current_job_role,
          company_name,
          phone,vetted,
          preferred_location,
          skill1,
          skill2,
          skill3,
          skill4,
          skill5,
          primarySkill,
          remark,
          };
        }
      ),
      filename: "error_list",
      delimiter: ",",
      headers: [
        "E-mail address",
        "Current CTC (In Lacs)",
        "Expected CTC (In Lacs)",
        "Negotiable",
        "Available on",
        "Current Location",
        "Notice Period (In days)",
        "Total Experience",
        "Current Job Role",
        "Company Name",
        "Mobile Number (10 Digits)",
        "Vetted",
        "Preferred Location",
        "Other Skill 1",
        "Other Skill 2",
        "Other Skill 3",
        "Other Skill 4",
        "Other Skill 5",
        "Primary Skill",
      ],
    };
    csvDownload(dataToConvert);
  };
  return (
    <div style={{ display: "flex" }}>
      {" "}
      <Sidemenu />
      <div style={{ padding: "100px", width: "100%" }}>
        <label
          for="upload"
          style={{
            border: "1px dashed grey",
            borderRadius: "10px",
            padding: "20px",
            background: "#F6FAFF",
            // width: "50%",
            marginBottom: "20px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            cursor: "pointer",
          }}
        >
          <input
            onChange={handleFile}
            type="file"
            id="upload"
            // style={{ padding: "20px" }}
            hidden
            accept=".csv"
            onClick={(e) => {
              e.target.value = null;
            }}
          />
          <div
            style={{
              display: "Flex",
              flexDirection: "column",
              justifyContent: "flex-start",
            }}
          >
            <p
              style={{
                fontStyle: "normal",
                fontWeight: 700,
                fontSize: "14px",
                marginTop: "0px",
                color: "#1E2228",
              }}
            >
              {" "}
              Choose file to upload
            </p>
            <span
              style={{
                fontWeight: 400,
                fontSize: "12px",

                color: "#506D85",
              }}
            >
              {" "}
              File format : Excel
            </span>
          </div>
          <span>
            <img alt="" src="./upload.svg" style={{ marginRight: "10px" }} />
          </span>
        </label>
        {loading && (
          <p style={{ fontWeight: "700", margin: "15px 0" }}>UPDATING....</p>
        )}
        {wrongCsvCheck&&<p style={{ fontWeight:"700",color: "red",margin: "15px 0" }}>{message}</p>}
{/* {console.log(errorCounter)} */}
        {errorMessage?.length>0&& <p style={{ fontWeight:"700",color: "red",margin: "15px 0" }}>{message}</p>}
        { errorMessage?.length>0 && (
          <Button
            type="primary"
            onClick={() => {
              downloadErrorFile();
            }}
            style={{
              borderRadius: "6px",
              marginRight: "10px",
              width: "200px",
            }}
            danger
          >
            Download file with errors
          </Button>
        )}
        {success&&<p style={{color:"green",fontWeight:"700",margin: "15px 0" }}>Successfully updated</p>}
      </div>
    </div>
  );
};

export default Parser;
